module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ki-4aad53ac2e36b7fae2941bfa905a9db1.svg";